import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as S from './styles';
export var StepperItem = forwardRef(function StepperItem(_a, ref) {
    var children = _a.children, onClick = _a.onClick, noPadding = _a.noPadding, className = _a.className, style = _a.style;
    var rootClass = cx(className);
    return (React.createElement(S.StepperItem, { flex: true, direction: 'column', onClick: onClick, padded: noPadding ? undefined : 'small', ref: ref, className: rootClass, style: style }, children));
});
StepperItem.defaultProps = {
    noPadding: false
};
StepperItem.displayName = 'StepperItem';
export default StepperItem;
//# sourceMappingURL=StepperItem.js.map